import store from "@/store";
import { addEventListener, removeEventListener } from "./event";
import { setBusinessId } from "./business.js";

export { addEventListener, removeEventListener };

export const initedPromise = new Promise(resolve => {
    addEventListener("inited", resolve);
});

/**
 * @description 检查是否有指定的权限
 * @export
 * @param {string|number} permit
 * @returns {boolean}
 */
export default function(permit) {
    return (store.state.auth.permit || []).indexOf(permit) > -1;
}

/**
 * @description 确认是否已经登陆
 * @export
 * @returns {boolean}
 */
export function isLogin() {
    return !!store.state.auth.mid;
}

/**
 * @description 确认是否业务数据加载完成
 * @export
 * @returns {boolean}
 */
export function isBusinessLoaded() {
    return !!store.state.auth.businessSetting;
}

/**
 * @description 获取当前鉴权 token
 * @export
 * @returns {string}
 */
export function getToken() {
    return store.state.auth.token;
}

/**
 * @description 获取当前业务Id
 * @export
 * @returns {boolean}
 */
export function getBusinessId() {
    return store.state.auth.businessId;
}

/**
 * @description 切换当前业务
 * @export
 * @returns {undefined}
 */
export function changeBusiness(businessId, noReload) {
    setBusinessId(businessId);
    noReload || window.location.reload(); // 切换业务之后，重新加载页面，更新业务数据
}

/**
 * @description 查看当前是否有指定业务
 * @export
 * @returns {boolean}
 */
export function checkModule(moduleId) {
    const businessSetting = store.state.auth.businessSetting || {};
    const modules = businessSetting.modules || [];
    return modules.indexOf(moduleId) != -1;
}

// 使用示例：
// addEventListener("inited", () => {
//   // your code here
// });
// addEventListener("logout", () => {
//   // your code here
// });
// initedPromise.then(() => {
//   // your code here
// })

// 留个半秒的缓冲，不然业务都没有机会等待 inited 事件了
setTimeout(() => store.dispatch("auth/update"), 500);
